import { render, staticRenderFns } from "./financialRatios.vue?vue&type=template&id=b0e21788&scoped=true"
import script from "./financialRatios.vue?vue&type=script&lang=js"
export * from "./financialRatios.vue?vue&type=script&lang=js"
import style0 from "./financialRatios.vue?vue&type=style&index=0&id=b0e21788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e21788",
  null
  
)

export default component.exports